import { formatDateShort } from "../components/Clinic/AdminPatients/clientSportDisplay";

export function isMembershipCurrentlyActive(m) {
  if (!m || m.status !== "active") return false;
  const today = new Date().toISOString().slice(0, 10);
  if (m.frozen_until && m.frozen_until >= today) return false;
  if (m.ends_at && m.ends_at < today) return false;
  if (m.visits_remaining != null && m.visits_remaining <= 0) return false;
  return true;
}

export function dayAfterDate(isoDate) {
  if (!isoDate) return null;
  const d = new Date(`${isoDate}T12:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
}

/** Можно ли выдать новый абонемент клиенту (не продление). */
export function analyzeMembershipAssignBlock(memberships, patientId) {
  const rows = (memberships || []).filter(
    (m) => String(m.patient_id) === String(patientId),
  );

  const pending = rows.find((m) => m.status === "pending");
  if (pending) {
    return {
      blocked: true,
      reason: "pending",
      message:
        "У клиента уже есть неоплаченный абонемент — сначала примите оплату.",
      pending,
    };
  }

  const frozen = rows.find((m) => m.status === "frozen");
  if (frozen) {
    return {
      blocked: true,
      reason: "frozen",
      message: "Абонемент заморожен. Новый можно выдать после завершения текущего.",
      frozen,
    };
  }

  const active = rows.find(isMembershipCurrentlyActive);
  if (active) {
    const canRenew = Boolean(active.ends_at);
    const renewalStartsAt = canRenew ? dayAfterDate(active.ends_at) : null;
    return {
      blocked: true,
      reason: "active",
      message: canRenew
        ? `Действует «${active.plan?.name || "абонемент"}» до ${formatDateShort(active.ends_at)}.`
        : `Действует «${active.plan?.name || "абонемент"}». Продление — после окончания.`,
      active,
      canRenew,
      renewalStartsAt,
    };
  }

  return { blocked: false };
}
